module.exports = __webpack_public_path__ + "fonts/IRANSansXV.d03d937c.woff";